export const sizes = {
    xs: {
        width: 16,
        height: 16,
    },
    sm: {
        width: 24,
        height: 24,
    },
    md: {
        width: 32,
        height: 32,
    },
    lg: {
        width: 48,
        height: 48,
    },
    xl: {
        width: 64,
        height: 64,
    },
    '2xl': {
        width: 96,
        height: 96,
    },
};
